import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import 'css/ViewCard.scss';

class ViewCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cardOpened: props.opened === 'yes',
        };
    }

    onLabelClick() {
        const { cardOpened } = this.state;
        this.setState({
            cardOpened: !cardOpened,
        });

        if (this.props.stateHandler) {
            this.props.stateHandler(!cardOpened);
        }
    }

    betAssistClick(e) {
        e.stopPropagation();
    }

    render() {
        return (
            <section
                className={classNames('view-card', {
                    expand: this.state.cardOpened,
                })}
            >
                <h4 onClick={this.onLabelClick.bind(this)}>
                    {this.props.label}
                    <i
                        className={classNames('fa', {
                            'fa-plus': !this.state.cardOpened,
                            'fa-minus': this.state.cardOpened,
                        })}
                        aria-hidden="true"
                    />
                </h4>
                {this.state.cardOpened && <div>{this.props.children}</div>}
            </section>
        );
    }
}

const mapStateToProps = (state) => ({ eventObject: state.eventObject });

export default connect(
    mapStateToProps,
    null
)(ViewCard);
